import { useState, useEffect } from 'react';
import UsersManagement from '@/components/admin/UsersManagement';
import { API } from '@/App';

export default function AdminUsersPage() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API}/admin/users`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        setUsers(await response.json());
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  return <UsersManagement users={users} onRefresh={fetchUsers} />;
}
